import {ChangeDetectorRef, Component, EventEmitter, Inject, OnInit, Output, ViewChild} from '@angular/core';
import {DialogService} from "../../../../services/core/dialog.service";
import {UntypedFormControl, UntypedFormGroup} from "@angular/forms";
import {TicketDetailComponent} from "../../../ticket/form-part/ticket-detail/ticket-detail.component";
import {AddChangeOrderComponent} from "../form-part/add-change-order/add-change-order.component";
import {NgDialogAnimationService} from 'src/app/services/core/ng-dialog-animation.service';
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {ToasterService} from "../../../../services/core/toaster.service";
import {BackendApiService} from "../../../../services/backend-api.service";
import {DrawingComponent} from "../form-part/drawing/drawing.component";
import {first} from "rxjs/operators";
import {ChangeOrderDataService} from "../change-order.data.service";
import {MatStepper} from "@angular/material/stepper";
import {HelperService} from "../../../../services/helper.service";

@Component({
    selector: 'app-create-change-order',
    templateUrl: './create-change-order.component.html',
    styleUrls: ['./create-change-order.component.scss'],
    standalone: false
})
export class CreateChangeOrderComponent implements OnInit {
  // @ts-ignore
  @ViewChild(AddChangeOrderComponent,{static:true}) AddChangeOrderComponent:AddChangeOrderComponent;
  // @ts-ignore
  @ViewChild(DrawingComponent,{static:true}) DrawingComponent:DrawingComponent;
  public addChangeOrderForm!: UntypedFormGroup;
  public model:any ={};
  public step:any;
  public finalPreview = false;
  public id: string = '';
  public isEdit:boolean = false;
  @Output() callback = new EventEmitter<any>(true);

  constructor(
    public dialogService: DialogService,
    public dialog: NgDialogAnimationService,
    private cd: ChangeDetectorRef,
    public helperService: HelperService,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public toasterService: ToasterService,
    public changeOrderDataService:ChangeOrderDataService,
    public dialogRef: MatDialogRef<CreateChangeOrderComponent>,
    public backendApiService: BackendApiService,
  ) {
    this.model = this.data?.model;
    this.id = this.data?.model?.id;
  }

  ngOnInit(): void {
    this.initChangeOrderForm()
  }
  initChangeOrderForm(){
    this.addChangeOrderForm = new UntypedFormGroup({
      step01: new UntypedFormGroup({
        changeOrder: new UntypedFormControl(null),
      }),
      step02: new UntypedFormGroup({
        drawingForm: new UntypedFormControl(null),
      }),
    });
  }
  close = (data:any = '') => {
    this.dialogService.onClose(data);
  }
  onStepChanged = (event:any, stepper:any) => {
    this.step = {event:event, stepper:stepper};
  }
  touchFormControls(formControlName: string, secondFormControlName: any = null){
    let addChangeOrderForm = this.addChangeOrderForm.get(formControlName);
    // @ts-ignore
    addChangeOrderForm = secondFormControlName ? addChangeOrderForm?.get(secondFormControlName) : addChangeOrderForm;
    addChangeOrderForm?.markAsTouched()
    addChangeOrderForm?.updateValueAndValidity({ onlySelf: false, emitEvent: true });
  }
  initChildForm(step: string, formControlName: string, value:any){
    this.addChangeOrderForm.get(step)?.get(formControlName)?.setValue(value);

  }
  onSubmit() {
    console.log(this.addChangeOrderForm.getRawValue());
    if (this.addChangeOrderForm.invalid) {
      this.toasterService.showWarning('Please fill all required field.');
      return;
    }
    const  changeOrderDataService = this.id ?
      this.changeOrderDataService.update(this.model.id , this.getFormData()) :
      this.changeOrderDataService.createFromJob(this.getFormData());

    changeOrderDataService
      .pipe(first())
      .subscribe(
        response => {
          console.log('response', response);
          const data= response.data?.data;
          console.log('data', data);
          this.callback.emit(data);
          this.addChangeOrderForm.reset();
          this.close(data);
          this.toasterService.showSuccessMessage(response?.data.message);
        });
  }
  getFormData = () => {
    const formValue = this.addChangeOrderForm.value;
    console.log(formValue);
    const payload = {
      job_id: formValue.step01.changeOrder.job_id,
      type: formValue.step01.changeOrder.orderType?.id,

      date: formValue.step02.drawingForm?.date,
      // type: formValue.step02.drawingForm?.type,
      number: formValue.step02.drawingForm?.number,
      file: formValue.step02.drawingForm?.file,
      // time: formValue.step02.drawingForm.time,


      // country_id: 231,

    };
    return payload;
  }
  finalPreviewFn(stepper: MatStepper){
    this.touchFormControls('step02','drawingForm');
    // @ts-ignore
    const isInvalid =this.addChangeOrderForm.get('step02').get('drawingForm').invalid;

    if (!isInvalid){
      stepper.next();
    }

  }
  cancelPreview(){
    this.finalPreview = false;
    this.step.event.selectedIndex = 2;
  }
  changedHandler = (event:any) => {
    console.log(event);
    const changeOrderDataService  = this.id ?
      this.changeOrderDataService.update(this.model.id , this.getFormData()) :
      this.changeOrderDataService.create(this.getFormData());

    changeOrderDataService
      .pipe(first())
      .subscribe(
        response => {
          const data= response.data?.data?.data;
          this.callback.emit(data);
          this.addChangeOrderForm.reset();
          this.close(data);
          this.toasterService.showSuccessMessage(data?.data.message);
        });
  }
}
